import { GeneralPreferences } from './../user-preferences/general-preferences.model';

export class Student {

    // Properties
    Id: number;
    FamilyId: number;
    StudentNumber: string;
    StudentDOENumber: string;
    SocialSecurityNumber: string;
    LastName: string;
    FirstName: string;
    MiddleName: string;
    NickName: string;
    DateOfBirth: string;
    Gender: string;
    Ethnicity: string;
    EMail: string;
    CellPhone: string;
    Age: number;
    Picture: Uint8Array;
    DisciplineCode: number;
    InvolvementType: string;
    IncidentComments: string;
    NonStudent: boolean;
    UnknownStudent: boolean;
    DRP_ID: number;
    DeletedFromReferral: boolean;
    PriorReferrals: number;
    EnrollmentId: number;
    EnrollmentSchool: string;
    EnrollmentDate: string;
    EnrollmentStatus: string;
    Enrollment: string;
    IEP: boolean;
    StudentAlerts: Alerts[];
    Grade: string;
    MemId: number;
    Suffix: string;
    PrimaryContact: boolean;
    SchoolName: string;
    EnrollDate: Date;
    WithdrawnDate: Date;
    AddedOn: Date;
    isSelected: boolean;
    SchoolDomain: number;
    HomeRoom_Class: string;
    Homeroom_CourseSection: string;
    Homeroom_Teacher: string;
    NewStudent: boolean;
    studentSelectionName: string;
    PickUp: boolean;
    DropOff: boolean;
    CanSee: boolean;
    DayOfWeek: string;

    // NON DTO Variable
    // ONE-6748
    EnrollmentDateAsDate: Date;
    DateOfBirthAsDate: Date;


    // Class Functions
    get fullName(): string {
        return this.LastName + ' ' + this.FirstName;
    }

    // Methods
    formattedNameWithNumber(generalPreferences: GeneralPreferences): string {
        let nameWithNumber = this.formattedName(generalPreferences);
        if (generalPreferences.ShowStudentNumber) {
            if (this.NonStudent) {
                nameWithNumber += ' (' + this.StudentNumber + ')';
            } else {
                nameWithNumber += ' (#' + this.StudentNumber + ')';
            }
        }
        return nameWithNumber;
    }

    formattedName(generalPreferences: GeneralPreferences): string {
        let formattedName = '';
        if (generalPreferences) {
            const nameFormat = generalPreferences.StudentNameFormat;
            const middleNameFormat = generalPreferences.StudentMiddleNameFormat;
            const showNickname = generalPreferences.ShowNickname;
            if (nameFormat != '') {
                if (nameFormat == 'LNF') {
                    formattedName = this.LastName + ', ';
                }
                if (nameFormat != 'FILN') {
                    formattedName += this.FirstName;
                }
                if (nameFormat == 'FILN') {
                    formattedName += this.FirstName.substr(0, 1);
                }
                if (showNickname && this.NickName != null && this.NickName != '') {
                    formattedName += ' "' + this.NickName + '"';
                }
                if (middleNameFormat == 'SEN' && this.MiddleName != null && this.MiddleName != '') {
                    formattedName += ' ' + this.MiddleName;
                }
                if (middleNameFormat == 'SFL' && this.MiddleName != null && this.MiddleName != '') {
                    formattedName += ' ' + this.MiddleName.substr(0, 1);
                }
                if (nameFormat != 'LNF' && nameFormat != 'FNLI') {
                    formattedName += ' ' + this.LastName;
                }
                if (nameFormat == 'FNLI') {
                    formattedName += ' ' + this.LastName.substr(0, 1);
                }
            }
        }
        return formattedName;
    }
    formattedNumber(generalPreferences: GeneralPreferences, overridePref: boolean = false): string {
        let studentNumber = '';
        if (generalPreferences.ShowStudentNumber || overridePref) {
            if (this.NonStudent) {
                studentNumber += ' (' + this.StudentNumber + ')';
            } else {
                studentNumber += ' ' + this.StudentNumber;
            }
        }
        return studentNumber;
    }
}

export class Alerts {
    Id: number;
    StudentId: number;
    AlertType: string;
    Program: string;
    Service: string;
    Description: string;
    StartDate: Date;
    EndDate: Date;
    AlertIcon: number[];
    Sequence: number;
    ContactName: string;
    ContactRelationship: string;
    UserHasPermisison: boolean;
    IsConfidential: boolean;
}